




















































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({
  components: {
  },
})
export default class AltSpinner extends Vue {
}
